import { ReceivingLogFormConfig} from '../../../../../../models/assets-data/receiving/ReceivingLogFormConfig.interface';
/**
 * Default receiving log form configuration used as a fallback if fetching the receiving-log-form-config.json file fails.
 * 
 * - Defines form structure, input fields, validation rules, and default values.
 * - Ensures essential fields like PO Number, Vendor, Job Details, and Print Options are properly configured.
 * - Supports different input types (text, number, select, toggle, textarea).
 * - Provides default configurations for 'Service' and 'Project' entries.
 * 
 * This ensures the receiving log form remains functional even if dynamic configuration retrieval fails.
 */
export const DEFAULT_ASSETS_RECEIVING_LOG_FORM: ReceivingLogFormConfig = {
        receivingLogForm: {
          requiredPoDigits: 6,
          inputs: {
            poNumber: {
              label: "PO Number",
              type: "input",
              inputType: "text",
              placeholder: "Enter PO Number",
              required: true,
              disabled: true,
              errorMsg: "Please enter a valid PO Number"
            },
            vendor: {
              label: "Vendor",
              type: "input",
              required: true
            },
            jobNumber: {
              label: "Job Number",
              type: "input",
              required: true
            },
            jobName: {
              label: "Job Name",
              type: "input",
              required: true
            },
            jcDept: {
              label: "JC Dept",
              type: "input",
              required: true
            },
            type: {
              label: "Type",
              type: "select",
              placeholder: "Select a Job Type",
              options: [
                { value: "Service", label: "Service" },
                { value: "Project", label: "Project" }
              ],
              required: true
            },
            qtyUnits: {
              label: "Quantity Units",
              type: "input",
              required: true
            },
            shelfLocation: {
              label: "Shelf Location",
              type: "input",
              required: true
            },
            shopSqFt: {
              label: "Shop Sq Ft",
              type: "input",
              inputType: "number",
              placeholder: "Enter sqft",
              required: true,
              errorMsg: "Please enter a valid number"
            },
            notify: {
              label: "Notify",
              type: "select",
              disabled: true,
              placeholder: "Click 'Edit Contacts' icon to update 'Notify' Field"
            },
            contact: {
              label: "Contact",
              type: "input"
            },
            items: {
              label: "Items",
              type: "textarea"
            },
            notes: {
              label: "Notes",
              type: "textarea"
            },
            printLabel: {
              label: "Print Label",
              type: "toggle"
            },
            printType: {
              label: "Print Label",
              type: "select",
              options: [
                { value: "dymo", label: "Label" },
                { value: "fullSheet", label: "Copier Sheet" },
                { value: "both", label: "Both" }
              ]
            },
            printQtySheet: {
              label: "Sheet Print QTY",
              type: "input",
              inputType: "number",
              errorMsg: "Please enter a valid number",
              required: true
            },
            printQtyDymo: {
              label: "Label Print QTY",
              type: "input",
              inputType: "number",
              errorMsg: "Please enter a valid number",
              required: true
            }
          },
          submitButtonText: "Submit Entry",
          defaults: {
            service: {
              type: "Service",
              shopSqFt: 1,
              printType: "Label",
              printQtyDymo: 1
            },
            project: {
              type: "Project",
              printType: "Both",
              printQtySheet: 1,
              printQtyDymo: 1
            }
          }
        }
      };
      